/**
 * Viewport helpers. Mobile breakpoint matches the repo's `sm` convention
 * (Bootstrap-style) used throughout styles.css.
 */

const MOBILE_QUERY = "(max-width: 767.98px)";

export function isMobileViewport(): boolean {
  return window.matchMedia(MOBILE_QUERY).matches;
}
